import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Snackbar,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import {
  getResiduos,
  postResiduo,
  getEnsambladoras,
  getTipos,
  getPermisosByUser,
  deleteResiduo,
} from '@auteco/services/sostenibilidadService'
import DateFnsUtils from '@date-io/date-fns'
import DeleteIcon from '@material-ui/icons/Delete'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

const SostenibilidadResiduosContainer = () => {
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [remision, setRemision] = useState('')
  const [material, setMaterial] = useState('')
  const [peso, setPeso] = useState('')
  const [tipoId, setTipoId] = useState('')
  const [ensambladoraId, setEnsambladoraId] = useState('')
  const [sedeId, setSedeId] = useState('')
  const [estrategiaId, setEstrategiaId] = useState('')
  const [archivo, setArchivo] = useState(null)
  const [ensambladoras, setEnsambladoras] = useState([])
  const [tipos, setTipos] = useState([])
  const [sedesList, setSedesList] = useState([])
  const [permisos, setPermisos] = useState(0)
  const [fecha, setFecha] = useState(null)
  const [touched, setTouched] = useState({})
  const [error, setError] = useState({ open: false, message: '' })

  const handleDeleteResiduo = async (id) => {
    try {
      const response = await deleteResiduo(id)
      if (response && response.data && response.data.success) {
        handleGetResiduos()
      } else {
        setError({ 
          open: true, 
          message: 'Error al eliminar el residuo. Por favor, intente nuevamente.' 
        })
      }
    } catch (err) {
      setError({ 
        open: true, 
        message: 'Error al eliminar el residuo. Por favor, intente nuevamente.' 
      })
    }
  }

  function formatearFechaEjemplo() {
    const fechaFormat = new Date(fecha)

    const año = fechaFormat.getFullYear()
    const mes = (fechaFormat.getMonth() + 1).toString().padStart(2, '0')
    const dia = fechaFormat.getDate().toString().padStart(2, '0')

    return `${año}-${mes}-${dia}`
  }

  const columns = [
    { title: 'Remisión', field: 'remision' },
    {
      title: 'Material',
      field: 'material',
      render: (rowData) => {
        const empresaFind = tipos.find((emp) => emp.id === rowData.material)
        return empresaFind ? empresaFind.nombre : 'Desconocida'
      },
    },
    { title: 'Peso (kg)', field: 'peso', type: 'numeric' },
    {
      title: 'Tipo material',
      field: 'tipo_id',
      type: 'numeric',
      render: (rowData) => {
        const empresaFind = tipos.find((emp) => emp.id === rowData.tipo_id)
        return empresaFind ? empresaFind.nombre : 'Desconocida'
      },
    },
    {
      title: 'Estrategia ',
      field: 'estrategia_nombre',
    },
    {
      title: 'Ensambladora ',
      field: 'ensambladora_nombre',
    },
    {
      title: 'Sede ID',
      field: 'sede_nombre',
    },
    {
      title: 'Fecha',
      field: 'fecha',
    },
    // corriente que es tipo 11 debe tener como padre el material que es tipo 2
    {
      title: 'Corriente',
      field: 'corriente',
      render: (rowData) => {
        const empresaFind = tipos.find((tipo) => tipo.tipo_id === '11' && tipo.padre_id === rowData.material)
        return empresaFind ? empresaFind.nombre : 'Desconocida' 
      }
    },
    {
      title: 'Archivo',
      field: 'archivo_url',
      render: (rowData) => (
        <IconButton onClick={() => window.open(rowData.archivo_url)}>
          <AttachFileIcon />
        </IconButton>
      ),
    },
    {
      title: 'Acción',
      field: 'accion',
      render: (rowData) => (
        <IconButton onClick={() => handleDeleteResiduo(rowData.id)}>
          <DeleteIcon />
        </IconButton>
      ),
    },
  ]

  const handleGetResiduos = async () => {
    try {
      const response = await getResiduos()
      if (response && response.residuos) {
        setData(response.residuos)
      } else {
        setError({ 
          open: true, 
          message: 'Error al cargar los residuos. Por favor, intente nuevamente.' 
        })
      }
    } catch (err) {
      setError({ 
        open: true, 
        message: 'Error al cargar los residuos. Por favor, intente nuevamente.' 
      })
    }
  }

  const handleGetEnsambladoras = async () => {
    try {
      const response = await getEnsambladoras()
      if (response && response.ensambladoras) {
        setEnsambladoras(response.ensambladoras)
      } else {
        setError({ 
          open: true, 
          message: 'Error al cargar las ensambladoras. Por favor, intente nuevamente.' 
        })
      }
    } catch (err) {
      setError({ 
        open: true, 
        message: 'Error al cargar las ensambladoras. Por favor, intente nuevamente.' 
      })
    }
  }

  const handleGetTipos = async () => {
    try {
      const response = await getTipos()
      if (response && response.tipos) {
        setTipos(response.tipos)
      } else {
        setError({ 
          open: true, 
          message: 'Error al cargar los tipos. Por favor, intente nuevamente.' 
        })
      }
    } catch (err) {
      setError({ 
        open: true, 
        message: 'Error al cargar los tipos. Por favor, intente nuevamente.' 
      })
    }
  }

  const handleAddResiduo = async () => {
    try {
      const reader = new FileReader()
      reader.onload = async () => {
        const base64Archivo = reader.result
        const payload = {
          remision,
          material,
          peso,
          tipo_id: tipoId,
          ensambladora_id: ensambladoraId,
          sede_id: sedeId,
          estrategia_id: estrategiaId,
          archivo: base64Archivo,
          fecha: formatearFechaEjemplo(),
        }

        const response = await postResiduo(payload)

        if (response.data && response.data.id) {
          setOpen(false)
          resetForm()
          handleGetResiduos()
        } else {
          setError({ 
            open: true, 
            message: 'Error al guardar el residuo. Por favor, intente nuevamente.' 
          })
        }
      }

      if (archivo) {
        reader.readAsDataURL(archivo)
      } else {
        const payload = {
          remision,
          material,
          peso,
          tipo_id: tipoId,
          ensambladora_id: ensambladoraId,
          sede_id: sedeId,
          estrategia_id: estrategiaId,
          fecha: formatearFechaEjemplo(),
        }
        const response = await postResiduo(payload)
        console.log(response)
        if (response.data && response.data.id) {
          setOpen(false)
          resetForm()
          handleGetResiduos()
        } else {
          setError({ 
            open: true, 
            message: 'Error al guardar el residuo. Por favor, intente nuevamente.' 
          })
        }
      }
    } catch (err) {
      setError({ 
        open: true, 
        message: 'Error al guardar el residuo. Por favor, intente nuevamente.' 
      })
    }
  }

  const handleEmpresaChange = (e) => {
    const selectedEmpresaId = e.target.value
    setEnsambladoraId(selectedEmpresaId)

    const selectedEmpresa = ensambladoras.find(
      (empresa) => empresa.id === selectedEmpresaId,
    )
    if (selectedEmpresa && selectedEmpresa.sedes) {
      const sedesValidas = selectedEmpresa.sedes.filter(sede => 
        sede && Object.keys(sede).length > 0
      )
      setSedesList(sedesValidas)
    } else {
      setSedesList([])
    }
  }

  const handleFieldTouch = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }))
  }

  const resetForm = () => {
    setRemision('')
    setMaterial('')
    setPeso('')
    setTipoId('')
    setEnsambladoraId('')
    setSedeId('')
    setEstrategiaId('')
    setArchivo(null)
    setFecha(null)
    setTouched({})
  }

  const handleClose = () => {
    setOpen(false)
    resetForm()
  }

  const handleGetPermisosByUser = async () => {
    const response = await getPermisosByUser()
    if (response) {
      const llantasPermiso = response.permisos.find(
        (permiso) => permiso.nombre === 'Residuos',
      )
      if (llantasPermiso) {
        setPermisos(llantasPermiso.alcance)
      }
    }
  }

  const handleCloseError = () => {
    setError({ open: false, message: '' })
  }

  useEffect(() => {
    handleGetResiduos()
    handleGetEnsambladoras()
    handleGetTipos()
    handleGetPermisosByUser()
  }, [])

  if (permisos < 1) {
    return <p>No tienes permisos para ver esta sección</p>
  }

  return (
    <div>
      {/* <p>{permisos}</p> */}
      <MaterialTable
        title="Residuos"
        columns={columns}
        data={data}
        options={{
          headerStyle: {
            backgroundColor: '#f1f1f1',
            color: 'black',
            fontWeight: 'bold',
          },
        }}
      />
      {permisos > 1 && (
        <Button
          style={{
            margin: '10px',
          }}
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
        >
          Agregar Residuos
        </Button>
      )}
      {/* Dialog para agregar residuo */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Agregar Residuo</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="remision"
            label="Remisión *"
            type="number"
            fullWidth
            required
            value={remision}
            onChange={(e) => setRemision(e.target.value)}
            onBlur={() => handleFieldTouch('remision')}
            style={{ marginBottom: '10px' }}
            error={touched.remision && !remision}
            helperText={touched.remision && !remision ? 'Campo requerido' : ' '}
          />
          <Select
            value={ensambladoraId}
            onChange={handleEmpresaChange}
            onBlur={() => handleFieldTouch('ensambladora')}
            displayEmpty
            style={{ marginBottom: '10px' }}
            fullWidth
            required
            error={touched.ensambladora && !ensambladoraId}
          >
            <MenuItem value="" disabled>
              Seleccionar ensambladora *
            </MenuItem>
            {ensambladoras.map((ens) => (
              <MenuItem key={ens.id} value={ens.id}>
                {ens.nombre}
              </MenuItem>
            ))}
          </Select>
          <Select
            value={sedeId}
            onChange={(e) => setSedeId(e.target.value)}
            onBlur={() => handleFieldTouch('sede')}
            style={{ marginBottom: '10px' }}
            displayEmpty
            fullWidth
            required
            disabled={!ensambladoraId}
            error={touched.sede && !sedeId}
          >
            <MenuItem value="" disabled>
              Sede *
            </MenuItem>
            {sedesList.map((sede) => (
              <MenuItem key={sede.id} value={sede.id.toString()}>
                {sede.nombre}
              </MenuItem>
            ))}
          </Select>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              id="fecha"
              label="Fecha *"
              format="dd/MM/yyyy"
              value={fecha}
              onChange={setFecha}
              onBlur={() => handleFieldTouch('fecha')}
              required
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              fullWidth
              error={touched.fecha && !fecha}
              helperText={touched.fecha && !fecha ? 'Campo requerido' : ' '}
            />
          </MuiPickersUtilsProvider>

          <Select
            value={tipoId}
            onChange={(e) => setTipoId(e.target.value)}
            onBlur={() => handleFieldTouch('tipo')}
            style={{ marginBottom: '10px' }}
            displayEmpty
            fullWidth
            required
            error={touched.tipo && !tipoId}
          >
            <MenuItem value="" disabled>
              Seleccionar tipo de material *
            </MenuItem>
            {tipos
              .filter((item) => item.tipo_id === '3')
              .map((mat) => (
                <MenuItem key={mat.id} value={mat.id}>
                  {mat.nombre}
                </MenuItem>
              ))}
          </Select>

          <Select
            value={material}
            onChange={(e) => setMaterial(e.target.value)}
            onBlur={() => handleFieldTouch('material')}
            style={{ marginBottom: '10px' }}
            displayEmpty
            fullWidth
            required
            error={touched.material && !material}
          >
            <MenuItem value="" disabled>
              Seleccionar material *
            </MenuItem>
            {tipos
              .filter(
                (item) =>
                  item.tipo_id === '2' &&
                  item.padre_id === tipoId &&
                  item.ensambladora_id === ensambladoraId,
              )
              .map((mat) => (
                <MenuItem key={mat.id} value={mat.id}>
                  {mat.nombre}
                </MenuItem>
              ))}
          </Select>
          <TextField
            margin="dense"
            id="peso"
            label="Peso (kg) *"
            type="number"
            fullWidth
            required
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
            onBlur={() => handleFieldTouch('peso')}
            error={touched.peso && !peso}
            helperText={touched.peso && !peso ? 'Campo requerido' : ' '}
          />

          <Select
            value={estrategiaId}
            onChange={(e) => setEstrategiaId(e.target.value)}
            onBlur={() => handleFieldTouch('estrategia')}
            style={{ marginBottom: '10px' }}
            displayEmpty
            fullWidth
            required
            error={touched.estrategia && !estrategiaId}
          >
            <MenuItem value="" disabled>
              Seleccionar estrategia *
            </MenuItem>
            {tipos
              .filter((item) => item.tipo_id === '7')
              .map((est) => (
                <MenuItem key={est.id} value={est.id}>
                  {est.nombre}
                </MenuItem>
              ))}
          </Select>
          <InputLabel htmlFor="archivo" error={touched.archivo && !archivo}>Archivo *</InputLabel>
          <input
            type="file"
            id="archivo"
            required
            onChange={(e) => setArchivo(e.target.files[0])}
            onBlur={() => handleFieldTouch('archivo')}
          />
          {touched.archivo && !archivo && (
            <p style={{ color: '#f44336', fontSize: '0.75rem', marginTop: '3px' }}>Campo requerido</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleAddResiduo}
            color="primary"
            disabled={
              !remision ||
              !material ||
              !peso ||
              !tipoId ||
              !ensambladoraId ||
              !sedeId ||
              !estrategiaId ||
              !fecha ||
              !archivo
            }
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar 
        open={error.open} 
        autoHideDuration={6000} 
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseError} severity="error">
          {error.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default SostenibilidadResiduosContainer
